var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",staticClass:"subscribe-modal",attrs:{"closeable":true},on:{"close":_vm.closed}},[_c('purchase-options',{attrs:{"current-variant":_vm.currentVariant},on:{"added-to-cart":_vm.closed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }